package music.jammers.client.shared.event.domain.model

data class ValidationError(
    val fieldName: String,
    val value: ValidationErrorValue,
)

sealed class ValidationErrorValue {

    data class StringMaxLength(
        val limit: Int,
        val actual: Int,
    ) : ValidationErrorValue()

    data object EmptyValue : ValidationErrorValue()

    data object InvalidSymbol : ValidationErrorValue()

    data class MustStartWith(
        val prefix: String,
    ) : ValidationErrorValue()

    data object InvalidDigit : ValidationErrorValue()

    data class MinInt(
        val value: Int,
    ) : ValidationErrorValue()

    data class MaxInt(
        val value: Int,
    ) : ValidationErrorValue()

    data object DateBeforeNow : ValidationErrorValue()

    data object InvalidDate : ValidationErrorValue()

    data object ItemNotSelected : ValidationErrorValue()

    data class ItemsMaxCount(
        val limit: Int,
        val actual: Int,
    ) : ValidationErrorValue()
}